import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { SectionHeading } from './Shared';
const faqs = [{
  q: 'Is this suitable for beginner coaches or only experienced ones?',
  a: "Volleyball Ready Pro was designed for coaches at every level. Whether you're stepping onto the court for the first time or you've been coaching for years, the system adapts to your needs and your team's level."
}, {
  q: 'Do I receive physical materials?',
  a: 'Everything is delivered digitally as PDF files. You receive instant access to the Complete Coaching Bible and 5 bonuses immediately after purchase — no waiting, no shipping.'
}, {
  q: 'Can I read it on my phone?',
  a: 'Absolutely. All PDFs are fully optimized for mobile, tablet and desktop reading. Access your materials on any device, anywhere, anytime.'
}, {
  q: 'Is this a theory course or a certification program?',
  a: 'No. This is a 100% practical operational system. No theory lectures, no certification requirements. Every page is immediately actionable — open it, adapt it and use it at your next practice.'
}, {
  q: 'Will this actually help me prepare faster?',
  a: 'Yes. Coaches who use Volleyball Ready Pro consistently report cutting their weekly preparation time by 60-70%. Everything is pre-structured — you adapt, not create from scratch.'
}, {
  q: 'What is the 7-day guarantee?',
  a: 'If for any reason you are not completely satisfied within 7 days of purchase, we will refund your payment in full. No questions asked. Zero risk.'
}];
export const FAQ = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-12 md:py-24 bg-navy-900 text-white" data-id="element-53">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-54">
        <SectionHeading data-id="element-55">Frequently Asked Questions</SectionHeading>

        <div className="space-y-3 md:space-y-4" data-id="element-56">
          {faqs.map((faq, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="border border-white/10 bg-navy-800 rounded-xl overflow-hidden" data-id="element-57">
              <button onClick={() => setOpenIndex(openIndex === idx ? null : idx)} className="w-full flex items-center justify-between p-4 md:p-6 text-left focus:outline-none focus:ring-2 focus:ring-vbgold hover:bg-navy-800/80 transition-colors" aria-expanded={openIndex === idx} data-id="element-58">
                <span className="font-bold text-base md:text-lg pr-4" data-id="element-59">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 md:w-6 md:h-6 text-vbgold transition-transform duration-300 flex-shrink-0 ${openIndex === idx ? 'rotate-180' : ''}`} data-id="element-60" />
              </button>
              <AnimatePresence data-id="element-61">
                {openIndex === idx && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} className="overflow-hidden" data-id="element-62">
                    <div className="p-4 md:p-6 pt-0 text-gray-300 text-sm md:text-base leading-relaxed border-t border-white/5" data-id="element-63">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
};